import React, { useState, useEffect, useRef, useContext } from 'react';
import CalendarioOperativo from '../../../Base/Components/CalendarioOperativo/CalendarioOperativo';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { getIngresosEncabezadoFechas } from '../../../API/Mantenimiento/Ingresos/IngresosRequests';
import Card from '../../../Base/Components/Card/Card';
import { Tag } from 'primereact/tag';
import { getInformacionEncabezadoCXP, postEstadoFinazasRegistros } from '../../../Base/API/CuentasPorPagar/CXP/CuentasPorPagarRequest';
import ModalCuentasPorPagarCompras from '../../../Base/Screens/Proveedores/CuentasPorPagar/ModalCXP/ModalCuentasPorPagarCompras';
import { getDateProduction } from '../../../Base/Services/FechasService';
import { Toast } from 'primereact/toast';
import { toastShow } from '../../../Base/Services/ToastService';
import Loader from '../../../Base/Components/Loader/Loader';
import { getDateTimeStringSQL, getDateTimeStringSQL24 } from '../../../Base/Services/Moment/Luxon';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { Checkbox } from 'primereact/checkbox';
import { CuentasPorPagarLang } from '../../../Base/Screens/Proveedores/CuentasPorPagar/Lang/CuentasPorPagarLang';
import { Button } from 'primereact/button';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

const IngresosBodegaEnc = () => {
    const toast = useRef(null)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [selected, setSelected] = useState([]);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [dialogFactura, setDialogFactura] = useState(false);
    const [IdFactura, setIdFactura] = useState(null);

    const { userAuth } = useContext(AuthContext)
    const {config} = useContext(ConfigContext)

    const obtenerIngresosFechas = async () => {
        setLoading(true)
        setData([])

        if (!dates[0] !== null) {
            if (!dates[1]) {
                toastShow(toast, 'warn', 'Error', 'Seleccione dos fechas para buscar');
            }
            else {
                const fechaFormato = getDateProduction(dates)
                const result = await getIngresosEncabezadoFechas(fechaFormato)
                setData(result)


            }

        } else {
            toastShow(toast, 'error', 'Error', 'Debe de selecionar una fecha.');
        }

        setLoading(false)

    }


    const EstadoTemplate = (rowData) => {
        switch (rowData.IdEstadoFinanzas) {
            case 3581:
                return <Tag style={{ width: 100, backgroundColor: "rgb(0, 191, 57)" }} value={rowData.StatusFinanzas} />
                break;
            case 3580:
                return <Tag style={{ width: 100, backgroundColor: "rgb(227, 63, 63)" }} value={rowData.StatusFinanzas} />
                break;
            case 3607:
                return <Tag style={{ width: 100, backgroundColor: "rgb(217, 206, 41)" }} value={rowData.StatusFinanzas} />
                break;
            case 3713:
                return <Tag style={{ width: 100, backgroundColor: "rgb(63, 142, 227)" }} value={rowData.StatusFinanzas} />
                break;
            case 3714:
                return <Tag style={{ width: 100, backgroundColor: "rgba(125, 129, 126, 0.75)" }} value={rowData.StatusFinanzas} />
                break;

            default:
                return <div><span>{rowData.StatusFinanzas}</span></div>
                break;
        }
    }

    const DiasVencidos = (DiasVencidos) => {
        if (DiasVencidos < 0) {
            return (
                <span style={{ color: 'green', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex'>{DiasVencidos}</span>
            )
        } else {
            return (
                <span style={{ color: 'red', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex' >{DiasVencidos}</span>
            )
        }
    }

    const OpenDocumento = async (rowData) => {
        let informacionEnviar = {
            IdIngreso: rowData?.IdIngreso,
            IdReferencia: rowData?.IdReferencia,
            NumeroIngreso: rowData?.NumeroIngreso
        }

        const tempoCXP = await getInformacionEncabezadoCXP(informacionEnviar)
        if (tempoCXP?.length > 0) {
            setIdFactura(tempoCXP[0]?.Id)
            setDialogFactura(true)
        }
    }

    const hideDialog = () => {
        setDialogFactura(false)
        obtenerIngresosFechas()
    }


    const RecibirFactura = async () => {
        setLoading(true)
        if (selected.length > 0) {
            let registroValidos = selected.filter((s) => [3713, 3714].includes(s?.IdEstadoFinanzas) === true)
            let registrosSinCAI = selected.filter((s) => s.IdCuenta === 15 && s.IdProveedorCAI === null && s.IdEstadoFinanzas !== 3713)
            if (registrosSinCAI?.length > 0) {
                toastShow(toast, 'error', 'Debe ingresar el CAI de la factura seleccionada')
            } else {
                let datosEnviar = registroValidos?.map((r) => {
                    return {
                        Id: r?.Id,
                        IdEstadoFinanzas: ([3580, 3714].includes(r?.IdEstadoFinanzas)) ? 3713 : 3714,
                        IdUserEditCompras: userAuth.idUser,
                        FechaEdit: getDateTimeStringSQL24(new Date()),
                        IdIngresoReferencia: r.IdIngreso,
                        IdReferencia: r.IdReferencia,
                        IsRegistroManual: r?.IsRegistroManual,
                        FechaRecibidoCompras: ([3580, 3714].includes(r?.IdEstadoFinanzas)) ? getDateTimeStringSQL24(new Date()) : null,
                        FechaRevisadoBodega: r.FechaRevisadoBodega

                    }
                });


                if (datosEnviar?.length > 0) {
                    const result = await postEstadoFinazasRegistros(datosEnviar)
                    if (result) {
                        if (result[0].ERROR === 0) {
                            toastShow(toast, 'success', result[0]?.MSJ)
                            obtenerIngresosFechas()
                        }
                        else {
                            toastShow(toast, 'error', result[0]?.MSJ)
                        }
                    }
                }
            }
            setLoading(false)
            setSelected([])
        }
    }

    const RevisadoBodega = async () => {
        setLoading(true)
        if (selected.length > 0) {
            let registroValidos = selected.filter((s) => [3580, 3714].includes(s?.IdEstadoFinanzas) === true)
            let registrosSinCAI = selected.filter((s) => s.IdCuenta === 15 && s.IdProveedorCAI === null && s.IdEstadoFinanzas !== 3714)

            if (registrosSinCAI.length > 0) {
                toastShow(toast, 'error', 'Debe ingresar el CAI de la factura seleccionada')
            } else {

                let datosEnviar = registroValidos?.map((r) => {
                    return {
                        Id: r?.Id,
                        IdEstadoFinanzas: r?.IdEstadoFinanzas === 3580 ? 3714 : 3580,
                        IdUserEditCompras: userAuth.idUser,
                        FechaEdit: getDateTimeStringSQL24(new Date()),
                        IdIngresoReferencia: r.IdIngreso,
                        IdReferencia: r.IdReferencia,
                        IsRegistroManual: r?.IsRegistroManual,
                        FechaRevisadoBodega: r?.IdEstadoFinanzas === 3580 ? getDateTimeStringSQL24(new Date()) : null,
                        FechaRecibidoCompras: null

                    }
                });


                if (datosEnviar?.length > 0) {
                    const result = await postEstadoFinazasRegistros(datosEnviar)
                    if (result) {
                        if (result[0].ERROR === 0) {
                            toastShow(toast, 'success', result[0]?.MSJ)
                            obtenerIngresosFechas()
                        }
                        else {
                            toastShow(toast, 'error', result[0]?.MSJ)
                        }
                    }
                }
            }
            setLoading(false)
            setSelected([])
        }
    }





    const table = {
        Data: data,
        selected: selected,
        setSelected: setSelected,
        Columns: [
            {
                field: 'Id',
                header: 'Id',
                headerEn: 'Id',
                className: 'Xsmall',
                width: 60,
                hidden: userAuth.IdRol === 1,
                frozen: 'true',
                alignFrozen: 'left',
            },

            {
                field: 'FechaIngreso',
                header: 'Fecha Ingreso',
                headerEn: 'Income Date',
                className: 'medium',
                Format: 'DateTime24',
                frozen: 'true',
                alignFrozen: 'left',
            },
            {
                field: 'StatusFinanzas',
                header: 'Estado',
                headerEn: 'Status',
                className: 'small',
                // Format: "Template",
                // body: (rowData) => EstadoTemplate(rowData),
                Format: 'Estado',
                body: (rowData) => ({
                    ID: rowData?.IdEstadoFinanzas,
                    Estado: rowData?.StatusFinanzas
                }),
                align: "center",
                alignFrozen: 'left'
            },
            {
                field: 'NumeroIngreso',
                header: 'Numero Ingreso',
                headerEn: 'Income Number',
                className: 'small',
                Sumary: 'count',
                Format: 'Center',
                align: "center",
                alignFrozen: 'left',
                onCellDoubleClicked: ({ data }) => {
                    console.log(data?.IdIngreso)
                    if (data?.IdIngreso) {
                        OpenDocumento(data)
                    }
                },
                sort: 'asc'
            },
            {
                field: 'PO',
                header: 'PO',
                className: 'small',
                Format: "Center",

            },
            {
                field: 'Factura',
                header: 'Factura',
                headerEn: 'Invoice',
                className: 'large',
            },
            {
                field: 'NoCAI',
                header: 'CAI',
                headerEn: 'CAI',
                className: 'Xlarge',
            },
            {
                field: 'OCE',
                header: 'OCE',
                headerEn: 'OCE',
                className: 'small',
                Format: 'Center'
            },
            {
                field: 'TermName',
                header: 'Terminos',
                headerEn: 'TermName',
                className: 'small',
                Format: 'Center'
            },
            {
                field: 'CustomerName',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'XXlarge',
            },
            {
                field: 'TipoIngreso',
                header: 'Tipo Ingreso',
                headerEn: 'Income Type',
                className: 'medium',
                Format: "Center"
            },
            {
                field: 'InvoiceDate',
                header: 'Fecha Factura',
                headerEn: 'Invoice Date',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'FechaVencido',
                header: 'Fecha Vencido',
                headerEn: 'Expired Date',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'DiasVencidos',
                header: 'Dias Vencidos',
                headerEn: 'Expired Days',
                className: 'Xsmall',
                Format: 'Template',
                body: rowData => DiasVencidos(rowData.DiasVencidos)
            },
            {
                field: 'AgentName',
                header: 'Agente Compras',
                headerEn: 'Purchase Agent',
                className: 'medium',
            },
            {
                field: 'Comentarios',
                header: 'Comentarios',
                headerEn: 'Comment',
                className: 'XXXlarge',

            },
            {
                field: 'CantidadDetalle',
                header: 'No. Items',
                className: 'Xsmall',
                Format: "Currency",
                Sumary: 'sum',
                align: "center"
            },
            {
                field: 'Id',
                header: 'Revisado Bodega ',
                headerEn: 'Revisado Bodega',
                className: 'Xsmall',
                Format: 'Template',
                frozen: true,
                alignFrozen: 'right',
                body: (data) => data.Id ? (
                    <div onClick={() => { if (selected.length === 0) setSelected([data]) }}
                        onDoubleClick={() => { if ([3580, 3714].includes(data?.IdEstadoFinanzas)) RevisadoBodega() }} className='d-flex flex-row' style={{ justifyContent: 'center' }}>
                        <Checkbox checked={[3581, 3607, 3713, 3714].includes(data?.IdEstadoFinanzas)} disabled={[3581, 3607, 3713].includes(data?.IdEstadoFinanzas)} />
                    </div>
                ) : null,
                hidden: [1, 1036].includes(userAuth.IdRol),

            },
            {
                field: 'Id',
                header: 'Recibido ',
                headerEn: 'Recibido',
                className: 'Xsmall',
                Format: 'Template',
                frozen: true,
                alignFrozen: 'right',
                body: (data) => data.Id ? (
                    <div onClick={() => { if (selected.length === 0) setSelected([data]) }}
                        onDoubleClick={() => { if ([3713, 3714].includes(data?.IdEstadoFinanzas)) RecibirFactura() }} className='d-flex flex-row' style={{ justifyContent: 'center' }}>
                        <Checkbox checked={[3581, 3607, 3713].includes(data?.IdEstadoFinanzas)} disabled={data.IdEstadoFinanzas === 3581 || data.IdEstadoFinanzas === 3607} />
                    </div>
                ) : null,
                hidden: [1, 8].includes(userAuth.IdRol),
            },
            {
                field: 'Ingreso',
                header: 'Ingreso',
                headerEn: 'Income',
                className: 'colum-width',
                Format: "Currency",
                editable: true,
                Sumary: 'sum'
            },

            {
                field: 'MontoL',
                header: 'Total L',
                headerEn: 'Amount L',
                className: 'small',
                Format: "Currency",
                editable: true,
                Sumary: 'sum',
                align: "center",
                frozen: 'true',
                alignFrozen: 'right',
            },

            {
                field: 'MontoD',
                header: 'Total $',
                headerEn: 'Amount $',
                className: 'small',
                Format: "Currency",
                editable: true,
                Sumary: 'sum',
                align: "center",
                frozen: 'true',
                alignFrozen: 'right',
            },



        ]
    }

    return (
        <div>
            <Toast ref={toast} />
            <Loader loading={loading} querySelector={'#IngresosMantenimientoEnc'} />
            <Card
                titulo={<div className='d-flex '> 
                    <CalendarioOperativo
                        getInfo={getIngresosEncabezadoFechas}
                        data={data}
                        setData={setData}
                        Nombre='Ingresos Bodega'
                        selected={selected}
                        setSelected={setSelected}
                        dates={dates}
                        setDates={setDates}
                        type='Month'
                        loading={loading}
                        setLoading={setLoading}
                    />

                    <Button icon='pi pi-plus' onClick={() => {
                        setIdFactura(null)
                        setDialogFactura(true)
                    }} style={{ height: 35 }} tooltip={getLabel(CuentasPorPagarLang, 'tooltipNuevo', config?.language)} />

                </div>}
                contenido={<div>
                    <div className='pt-4' style={{ height: '85vh' }} id='IngresosMantenimientoEnc'>
                        <AgGrid table={table} />
                    </div>
                </div>}
            />
            <ModalCuentasPorPagarCompras
                dialogCuentas={dialogFactura}
                hideDialog={hideDialog}
                IdFactura={IdFactura}

            />

        </div>
    )
}

export default IngresosBodegaEnc